import { library } from "@fortawesome/fontawesome-svg-core";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Alert, Modal } from "react-bootstrap";

library.add(faWarning);

type UserProcessingProps = {
  show: boolean;
  handleClose: () => void;
};
export default function OwnerDataProcessinggModal({
  show,
  handleClose,
}: UserProcessingProps) {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Body>
        <div className="flex justify-center">
          <img
            className="w-36"
            src="/images/spinner.gif"
            alt="Essilor Logo"
          />
        </div>
        <h3 className="text-center font-bold">Loading your data...</h3>
        <p className="my-4">
          We're processing a large dataset for you. This may take up to a minute
          to complete.
        </p>
        <Alert variant="warning">
          <div className="flex gap-2">
            <FontAwesomeIcon icon="warning" className="mt-1 mr-1" />
            <div>
              <h4 className="font-semibold">Please don't refresh the page</h4>
              <p className="mt-2">
                Refreshing will cancel the process and you'll need to start
                over.
              </p>
            </div>
          </div>
        </Alert>
      </Modal.Body>
    </Modal>
  );
}
